import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
// 重复点击菜单报错问题解决
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: resolve => require(['@/components/Login'], resolve)
    },
    {
      path: '/shouju',
      name: 'shouju',
      component: resolve => require(['@/components/documentaryevidence'], resolve)
    },
    {
      path: '/shouju2',
      name: 'shouju2',
      component: resolve => require(['@/components/documentaryevidence2'], resolve)
    },
    {
      path: '/shenqing',
      name: 'shenqing',
      component: resolve => require(['@/components/renewal'], resolve)
    }
    ,
    {
      path: '/MemberDocumentaryEvidence',
      name: 'MemberDocumentaryEvidence',
      component: resolve => require(['@/components/MemberDocumentaryEvidence'], resolve)
    },
    {
      path: '/zhengshuchaxun',
      name: 'zhengshuchaxun',
      component: resolve => require(['@/components/zhengshuchaxun'], resolve)
    },
    {
      path: '/MemberSearch',
      name: 'MemberSearch',
      component: resolve => require(['@/components/MemberSearch'], resolve)
    },
    {
      path: '/GroupMemberSearch',
      name: 'GroupMemberSearch',
      component: resolve => require(['@/components/GroupMemberSearch'], resolve)
    },
    {
      path: '/membercenter/vipLogin',
      name: '会员登录',
      component: resolve => require(['@/components/membercenter/vipLogin'], resolve)
    },
    {
      path: "/rehear/rehearList",
      name: "复听申请列表页",
      component: resolve => require(['@/components/rehear/rehearList'], resolve)
    },
    {
      path: "/rehear/rehearApply",
      name: "复听申请",
      component: resolve => require(['@/components/rehear/rehearApply'], resolve)
    },
    {
      path: "/rehear/rehearSearch",
      name: "复听申请结果查询",
      component: resolve => require(['@/components/rehear/rehearSearch'], resolve)
    },
    {
      path: "/rehear/onlineCourse",
      name: "网课学习账号查询",
      component: resolve => require(['@/components/rehear/onlineCourse'], resolve)
    },
    {
      path: "/rehear/shalong",
      name: "沙龙活动申请表",
      component: resolve => require(['@/components/rehear/shalong'], resolve)
    },
    {
      path: '/home',
      name: '',
      component: resolve => require(['@/components/Home'], resolve),
      children: [
        {
          path: '/index',
          name: '',
          component: resolve => require(['@/components/index/index'], resolve)
        },
        {
          path: '/channelmanagement/addchannel',
          name: '新增渠道',
          component: resolve => require(['@/components/channelManagement/addChannel'], resolve)
        },
        {
          path: '/student/studentLists',
          name: '超星学员账号',
          component: resolve => require(['@/components/student/studentLists'], resolve)
        },
        {
          path: '/pay/payList',
          name: '缴费',
          component: resolve => require(['@/components/pay/payList'], resolve),
          children: [
            {
              path: '/invoiceprocessing/onlinepayment',
              name: '线上缴费',
              component: resolve => require(['@/components/invoiceprocessing/OnlinePayment'], resolve)
            },

            {
              path: '/invoiceprocessing/selfpayrecord',
              name: '线下个人缴费',
              component: resolve => require(['@/components/invoiceprocessing/selfPayRecord'], resolve),
            },
            {
              path: '/invoiceprocessing/proAccountSearch',
              name: 'datahoop账号',
              component: resolve => require(['@/components/invoiceprocessing/proAccountSearch'], resolve),
            },
            //渠道缴费列表
            {
              path: '/invoiceprocessing/channelPayRecord',
              name: '线下渠道缴费',
              component: resolve => require(['@/components/invoiceprocessing/channelPayRecord'], resolve),
              meta: {
                // keepAlive: true //此页面需要缓存
              }
            },
            {
              path: '/invoiceprocessing/datahoop',
              name: 'datahoop缴费',
              component: resolve => require(['@/components/invoiceprocessing/datahoop'], resolve),
            },
          ]
        },

        {
          path: '/daiban/daiban',
          name: '待办事项',
          component: resolve => require(['@/components/daiban/daiban'], resolve),
          // redirect:'/daiban/chanelGover',
          children: [
            {
              path: '/daiban/chanelGover',
              name: '', //渠道成交部门长审核列表
              component: resolve => require(['@/components/daiban/chanelGover'], resolve)
            },
            {
              path: '/daiban/chanelGovers',
              name: '', //渠道成交财务审核列表
              component: resolve => require(['@/components/daiban/chanelGovers'], resolve)
            },
            {
              path: '/daiban/moneyGover',
              name: '', // 渠道终止协议列表
              component: resolve => require(['@/components/daiban/moneyGover'], resolve)
            },
            {
              path: '/daiban/moneyPresident',
              name: '', // 渠道终止协议会长审核
              component: resolve => require(['@/components/daiban/moneyPresident'], resolve)
            },
            {
              path: '/daiban/chanelTuifei',
              name: '', //渠道终止协议退费
              component: resolve => require(['@/components/daiban/chanelTuifei'], resolve)
            },
            {
              path: '/daiban/chanelBack',
              name: '', // 渠道退回记录
              component: resolve => require(['@/components/daiban/chanelBack'], resolve)
            },
            {
              path: '/daiban/channelStorage',
              name: '', // 渠道退回教材入库
              component: resolve => require(['@/components/daiban/channelStorage'], resolve)
            },
            {
              path: '/daiban/personMoney',
              name: '', // 个人缴费列表
              component: resolve => require(['@/components/daiban/personMoney'], resolve)
            },
            {
              path: '/daiban/chanelMoney',
              name: '', // 渠道缴费列表
              component: resolve => require(['@/components/daiban/chanelMoney'], resolve)
            },
            {
              path: '/daiban/chanellMoney',
              name: '', //渠道退费列表
              component: resolve => require(['@/components/daiban/chanellMoney'], resolve)
            },
            {
              path: '/daiban/channelCashHead',
              name: '', //渠道押金退费部门长审核
              component: resolve => require(['@/components/daiban/channelCashHead'], resolve)
            },
            {
              path: '/daiban/channelCashAudit',
              name: '', //渠道押金退费财务审核
              component: resolve => require(['@/components/daiban/channelCashAudit'], resolve)
            },
            {
              path: '/daiban/channelCashTrue',
              name: '', //渠道押金退费财务确认
              component: resolve => require(['@/components/daiban/channelCashTrue'], resolve)
            },
            {
              path: '/daiban/courseJeSuan',
              name: '', // 课酬结算
              component: resolve => require(['@/components/daiban/courseJeSuan'], resolve)
            },
            {
              path: '/daiban/waitJeSuan',
              name: '', // 待结算课酬
              component: resolve => require(['@/components/daiban/waitJeSuan'], resolve)
            },
            {
              path: '/daiban/onlineMoney',
              name: '', // 线上缴费
              component: resolve => require(['@/components/daiban/onlineMoney'], resolve)
            },
            {
              path: '/daiban/ticketApply',
              name: '', // 发票申请列表
              component: resolve => require(['@/components/daiban/ticketApply'], resolve)
            },
            {
              path: '/daiban/memberMony',
              name: '', // 会员缴费
              component: resolve => require(['@/components/daiban/memberMony'], resolve)
            },
            {
              path: '/daiban/memberList',
              name: '', // 学员列表
              component: resolve => require(['@/components/daiban/memberList'], resolve)
            },
            {
              path: '/daiban/infoEdit',
              name: '', // 基本信息修改申请列表
              component: resolve => require(['@/components/daiban/infoEdit'], resolve)
            },
            {
              path: '/daiban/wishMember',
              name: '', // 意向学员列表
              component: resolve => require(['@/components/daiban/wishMember'], resolve)
            },
            {
              path: '/daiban/wishPush',
              name: '', // 意向学员推送列表
              component: resolve => require(['@/components/daiban/wishPush'], resolve)
            },
            // {
            //   path: '/daiban/talent',
            //   name: '', // 人才库列表
            //   component: resolve => require(['@/components/daiban/talent'], resolve)
            // },
            {
              path: '/daiban/classList',
              name: '', // 班级列表
              component: resolve => require(['@/components/daiban/classList'], resolve)
            },
            {
              path: '/daiban/Openingaudit',
              name: '', // 开班申请部门长审核
              component: resolve => require(['@/components/daiban/Openingaudit'], resolve)
            },
            {
              path: '/daiban/specialClass',
              name: '', // 特殊开班申请列表
              component: resolve => require(['@/components/daiban/specialClass'], resolve)
            },
            {
              path: '/daiban/SpeciClass',
              name: '', // 特殊开班申请
              component: resolve => require(['@/components/daiban/SpeciClass'], resolve)
            },
            {
              path: '/daiban/classApply',
              name: '', // 调整开班时间列表
              component: resolve => require(['@/components/daiban/classApply'], resolve)
            },
            // {
            //   path: '/daiban/classDate',
            //   name: '', // 特殊上课日期申请列表
            //   component: resolve => require(['@/components/daiban/classDate'], resolve)
            // },
            {
              path: '/daiban/specialFentan',
              name: '', // 特殊分摊列表
              component: resolve => require(['@/components/daiban/specialFentan'], resolve)
            },
            {
              path: '/daiban/classGryh',
              name: '', // 个人优惠列表
              component: resolve => require(['@/components/daiban/classGryh'], resolve)
            },
            {
              path: '/daiban/Customer',
              name: '', // 客服继续教育后通知列表
              component: resolve => require(['@/components/daiban/Customer'], resolve)
            },
            {
              path: '/daiban/refund',
              name: '', // 线上退费
              component: resolve => require(['@/components/daiban/refund'], resolve)
            },
            {
              path: '/daiban/dhAudit',
              name: '', // DH会员账号审核
              component: resolve => require(['@/components/daiban/dhAudit'], resolve)
            },
          ]
        },
        {
          path: '/channelmanagement/channellist',
          name: '渠道成交列表',
          component: resolve => require(['@/components/channelManagement/channellist'], resolve),
          meta: {
            keepAlive: true //此页面需要缓存
          }
        },
        {
          path: '/channelmanagement/channelTransaction',
          name: '意向渠道列表',
          component: resolve => require(['@/components/channelManagement/channelTransaction'], resolve),
        },
        {
          path: '/channelmanagement/channelTransactiondetail',
          name: '意向渠道详情页',
          component: resolve => require(['@/components/channelManagement/channelTransactiondetail'], resolve),
        },
        {
          path: '/channelmanagement/channeldetail/:id',
          name: '渠道详情',
          component: resolve => require(['@/components/channelManagement/channeldetail'], resolve)
        },
        {
          path: '/channelmanagement/channelaccountdetail',
          name: '渠道账户详情页',
          component: resolve => require(['@/components/channelManagement/channelAccountDetail'], resolve)
        },
        {
          path: '/channelmanagement/adjust/:id',
          name: '渠道调库',
          component: resolve => require(['@/components/channelManagement/adjust'], resolve)
        },
        {
          path: '/channelmanagement/channelzhongzhixieyi/',
          name: '渠道终止协议',
          component: resolve => require(['@/components/channelManagement/channelzhongzhixieyi'], resolve)
        },
        //线下缴费记录
        // 新增缴费信息
        {
          path: '/invoiceprocessing/addpayment',
          name: '新增缴费信息',
          component: resolve => require(['@/components/invoiceprocessing/addpayment'], resolve)
        },
        {
          path: '/invoiceprocessing/addselfpayrecord',
          name: '新增线下个人缴费',
          component: resolve => require(['@/components/invoiceprocessing/addselfpayrecord'], resolve)
        },
        // 渠道缴费
        {
          path: '/invoiceprocessing/addchannelpayrecord',
          name: '新增渠道缴费信息',
          component: resolve => require(['@/components/invoiceprocessing/addchannelpayrecord'], resolve)
        },
        // // 会员缴费
        // {
        //   path: '/invoiceprocessing/addmemberPayInfo',
        //   name: '新增会员缴费信息',
        //   component: resolve => require(['@/components/invoiceprocessing/addmemberPayInfo'], resolve)
        // },
        //个人缴费列表

        {
          path: '/invoiceprocessing/selfPayList',
          name: '线下个人缴费详情',
          component: resolve => require(['@/components/invoiceprocessing/selfPayList'], resolve)
        },
        {
          path: '/Invoiceprocessing/onlinepaymentList',
          name: '线上缴费详情',
          component: resolve => require(['@/components/invoiceprocessing/onlinepaymentList'], resolve)
        },

        {
          path: '/invoiceprocessing/channelPayList',
          name: '线下渠道缴费详情',
          component: resolve => require(['@/components/invoiceprocessing/channelPayList'], resolve)
        },
        //渠道退费列表
        {
          path: '/invoiceprocessing/channelPayRetreat',
          name: '线下渠道退费',
          component: resolve => require(['@/components/invoiceprocessing/channelPayRetreat'], resolve),
          meta: {
            keepAlive: true //此页面需要缓存
          }
        },
        // {
        //   path: '/invoiceprocessing/ChannelTerminationRefund',
        //   name: '渠道终止协议退费',
        //   component: resolve => require(['@/components/invoiceprocessing/ChannelTerminationRefund'], resolve)
        // },
        {
          path: '/invoiceprocessing/ChannelTerminationRefunddetail',
          name: '渠道终止协议退费详情',
          component: resolve => require(['@/components/invoiceprocessing/ChannelTerminationRefunddetail'], resolve)
        },
        {
          path: '/invoiceprocessing/examine',
          name: '渠道终止协议退费--查看',
          component: resolve => require(['@/components/invoiceprocessing/examine'], resolve)
        },
        {
          path: '/invoiceprocessing/channelPayRetreatList',
          name: '线下渠道退费详情',
          component: resolve => require(['@/components/invoiceprocessing/channelPayRetreatList'], resolve)
        },
        // {
        //   path: '/invoiceprocessing/ExamFoundList',
        //   name: '考试报名退款',
        //   component: resolve => require(['@/components/invoiceprocessing/ExamFoundList'], resolve)
        // },
        //会员缴费列表
        {
          path: '/invoiceprocessing/memberPayInfo',
          name: '会员缴费列表',
          component: resolve => require(['@/components/invoiceprocessing/memberPayInfo'], resolve),
        },
        {
          path: '/invoiceprocessing/memberPayInfoDetail',
          name: '会员缴费详情',
          component: resolve => require(['@/components/invoiceprocessing/memberPayInfoDetail'], resolve)
        },
        // {
        //   path: '/invoiceprocessing/departmentrevenuesummary',
        //   name: '部门收入汇总',
        //   component: resolve => require(['@/components/invoiceprocessing/departmentrevenuesummary'], resolve)
        // },
        {
          path: '/invoiceprocessing/DollarsSettlement',
          name: '课酬结算',
          component: resolve => require(['@/components/invoiceprocessing/DollarsSettlement'], resolve),
          meta: {
            keepAlive: true //此页面需要缓存
          }
        },
        {
          path: '/invoiceprocessing/DollarsSettlementdetails',
          name: '课酬结算详情页',
          component: resolve => require(['@/components/invoiceprocessing/DollarsSettlementdetails'], resolve)
        },
        {
          path: '/invoiceprocessing/PaymentToBeSettled',
          name: '待结算课酬',
          component: resolve => require(['@/components/invoiceprocessing/PaymentToBeSettled'], resolve)
        },
        {
          path: '/invoiceprocessing/PaymentToBeSettleddetails',
          name: '待结算课酬详情页',
          component: resolve => require(['@/components/invoiceprocessing/PaymentToBeSettleddetails'], resolve)
        },
        // {
        //   path: '/invoiceprocessing/onlineinvoice',
        //   name: '线上发票信息',
        //   component: resolve => require(['@/components/invoiceprocessing/onlineinvoice'], resolve)
        // },
        {
          path: '/invoiceprocessing/memberpayinfo',
          name: '新增会员缴费信息',
          component: resolve => require(['@/components/invoiceprocessing/memberPayInfo'], resolve)
        },

        {
          path: '/teacherManage/newTeachers',
          name: '新增教师',
          component: resolve => require(['@/components/teacherManage/newTeachers'], resolve)
        },
        {
          path: '/teacherManage/teachersList',
          name: '教师列表',
          component: resolve => require(['@/components/teacherManage/teachersList'], resolve),
          meta: {
            keepAlive: true //此页面需要缓存
          }
        },
        {
          path: '/teacherManage/giveaclass',
          name: '讲师上课记录',
          component: resolve => require(['@/components/teacherManage/giveaclass'], resolve),
        },
        // {
        //   path: '/teacherManage/costlist',
        //   name: '交通费用记录',
        //   component: resolve => require(['@/components/teacherManage/costlist'], resolve)
        // },
        // {
        //   path: '/teacherManage/changeclass',
        //   name: '讲师上课变更记录',
        //   component: resolve => require(['@/components/teacherManage/changeclass'], resolve)
        // },
        {
          path: '/teacherManage/noclass',
          name: '不上课页面',
          component: resolve => require(['@/components/teacherManage/noclass'], resolve)
        },
        {
          path: '/teacherManage/teacherdetail',
          name: '教师详情',
          component: resolve => require(['@/components/teacherManage/teacherdetail'], resolve)
        },
        {
          path: '/teacherManage/performance',
          name: '成绩复核申请',
          component: resolve => require(['@/components/teacherManage/performance'], resolve)
        },
        {
          path: '/StockControl/storagelist',
          name: '库存列表',
          component: resolve => require(['@/components/StockControl/storageList'], resolve)
        },
        {
          path: '/StockControl/thirdstock',
          name: '第三方库存',
          component: resolve => require(['@/components/StockControl/thirdStock'], resolve)
        },
        {
          path: '/StockControl/applystorage',
          name: '入库申请',
          component: resolve => require(['@/components/StockControl/applyStorage'], resolve)
        },
        {
          path: '/StockControl/applystoragelist',
          name: '入库列表',
          component: resolve => require(['@/components/StockControl/applyStorageList'], resolve),
          meta: {
            keepAlive: true //此页面需要缓存
          }
        },
        {
          path: '/StockControl/applystoragedetail/:id',
          name: '入库详情页',
          component: resolve => require(['@/components/StockControl/applyStorageDetail'], resolve)
        },
        {
          path: '/StockControl/channelreturn',
          name: '渠道退回记录',
          component: resolve => require(['@/components/StockControl/channelReturn'], resolve),
          meta: {
            keepAlive: true //此页面需要缓存
          }
        },
        {
          path: '/StockControl/channelreturndetail/:id',
          name: '渠道退回记录详情',
          component: resolve => require(['@/components/StockControl/channelReturnDetail'], resolve)
        },
        {
          path: '/StockControl/outstockapply/:id',
          name: '出库申请',
          component: resolve => require(['@/components/StockControl/outStockApply'], resolve)
        },
        {
          path: '/StockControl/outstocklist',
          name: '出库申请列表',
          component: resolve => require(['@/components/StockControl/outStockList'], resolve),
          meta: {
            keepAlive: true //此页面需要缓存
          }
        },
        {
          path: '/StockControl/outstockdetail/:id',
          name: '出库列表详情',
          component: resolve => require(['@/components/StockControl/outStockDetail'], resolve)
        },
        {
          path: '/StockControl/outstockall',
          name: '出库汇总列表',
          component: resolve => require(['@/components/StockControl/outStockAll'], resolve)
        },
        {
          path: '/StockControl/channelstock',
          name: '渠道库存',
          component: resolve => require(['@/components/StockControl/channelStock'], resolve),
          meta: {
            keepAlive: true //此页面需要缓存
          }
        },
        {
          path: '/StockControl/adjustlist',
          name: '调库列表',
          component: resolve => require(['@/components/StockControl/adjustList'], resolve),
        },
        {
          path: '/StockControl/adjustlistdetail/:id',
          name: '渠道调库详情页',
          component: resolve => require(['@/components/StockControl/adjustListDetail'], resolve)
        },
        {
          path: '/StockControl/infomanagement',
          name: '信息管理',
          component: resolve => require(['@/components/StockControl/infoManagement'], resolve)
        },
        {
          path: '/StockControl/channelstockdetail',
          name: '渠道库存详情',
          component: resolve => require(['@/components/StockControl/channelStockDetail'], resolve)
        },
        {
          path: '/StockControl/inventory',
          name: '盘库历史',
          component: resolve => require(['@/components/StockControl/inventory'], resolve)
        },
        {
          path: '/StockControl/inventoryDetail',
          name: '盘库历史详情',
          component: resolve => require(['@/components/StockControl/inventoryDetail'], resolve)
        },

        // 班级管理
        {
          path: '/classlist/addclass',
          name: '创建班级',
          component: resolve => require(['@/components/classlist/addclass'], resolve)
        },
        {
          path: '/classlist/classlist',
          name: '班级列表',
          component: resolve => require(['@/components/classlist/classlist'], resolve),
          meta: {
            keepAlive: true //此页面需要缓存
          }
        },
        {
          path: '/classlist/classaddstudent',
          name: '班级添加学员',
          component: resolve => require(['@/components/classlist/classaddstudent'], resolve)
        },
        {
          path: '/classlist/classdetails',
          name: '班级详情',
          component: resolve => require(['@/components/classlist/classdetails'], resolve)
        },
        {
          path: '/classlist/costallocation',
          name: '费用分摊',
          component: resolve => require(['@/components/classlist/costallocation'], resolve)
        },
        {
          path: '/classlist/classOpeningApply',
          name: '特殊开班申请列表',
          component: resolve => require(['@/components/classlist/classOpeningApply'], resolve)
        },
        {
          path: '/classlist/classtimeApply',
          name: '特殊开班时间申请列表',
          component: resolve => require(['@/components/classlist/classtimeApply'], resolve)
        },
        {
          path: '/classlist/classattendApply',
          name: '特殊上课日申请列表',
          component: resolve => require(['@/components/classlist/classattendApply'], resolve),
        },
        {
          path: '/classlist/classattendApplydetails',
          name: '特殊上课日申请列表详情页',
          component: resolve => require(['@/components/classlist/classattendApplydetails'], resolve)
        },
        {
          path: '/classlist/classshareApply',
          name: '特殊分摊列表',
          component: resolve => require(['@/components/classlist/classshareApply'], resolve)
        },
        {
          path: '/classlist/reclassaddstudent',
          name: '第二次设计的班级添加学员页面',
          component: resolve => require(['@/components/classlist/reclassaddstudent'], resolve)
        },
        {
          path: '/classlist/teacherAllocation',
          name: '教师配置',
          component: resolve => require(['@/components/classlist/teacherAllocation'], resolve)
        },
        {
          path: '/Invoiceprocessing/payment',
          name: '考试报名缴费',
          component: resolve => require(['@/components/Invoiceprocessing/payment'], resolve)
        },

        {
          path: '/Invoiceprocessing/paymentlist',
          name: '线上缴费详情',
          component: resolve => require(['@/components/Invoiceprocessing/paymentlist'], resolve)
        },
        // 发票部分
        {
          path: '/invoiceprocessing/addInvoicelist',
          name: '新增个人缴费开票',
          component: resolve => require(['@/components/invoiceprocessing/addInvoicelist'], resolve)
        },
        {
          path: '/Invoiceprocessing/Invoicelist',
          name: '发票列表',
          component: resolve => require(['@/components/Invoiceprocessing/Invoicelist'], resolve),
        },
        {
          path: '/Invoiceprocessing/Invoicedetails',
          name: '发票列表详情',
          component: resolve => require(['@/components/Invoiceprocessing/Invoicedetails'], resolve)
        },
        {
          path: '/Invoiceprocessing/Invoicemanagement',
          name: '在线发票列表',
          component: resolve => require(['@/components/Invoiceprocessing/Invoicemanagement'], resolve)
        },
        {
          path: '/StudentInfo/studentlist',
          name: '学员信息列表',
          component: resolve => require(['@/components/StudentInfo/studentlist'], resolve),
          meta: {
            keepAlive: true //此页面需要缓存
          }
        },
        {
          path: '/StudentInfo/studentdetails',
          name: '学员信息详情',
          component: resolve => require(['@/components/StudentInfo/studentdetails'], resolve)
        },
        {
          path: '/StudentInfo/studentdetails1',
          name: '变更正式学员信息',
          component: resolve => require(['@/components/StudentInfo/studentdetails1'], resolve)
        },
        {
          path: '/StudentInfo/StudentRevisionReview',
          name: '学员基本信息修改',
          component: resolve => require(['@/components/StudentInfo/StudentRevisionReview'], resolve),
        },
        {
          path: '/StudentInfo/yixiangstudent',
          name: '意向学员列表',
          component: resolve => require(['@/components/StudentInfo/yixiangstudent'], resolve),
          meta: {
            keepAlive: true //此页面需要缓存
          }
        },
        {
          path: '/StudentInfo/yixiangstudentdetails',
          name: '意向学员详情',
          component: resolve => require(['@/components/StudentInfo/yixiangstudentdetails'], resolve)
        },
        {
          path: '/StudentInfo/yixiangstudentPust',
          name: '意向学员推送列表',
          component: resolve => require(['@/components/StudentInfo/yixiangstudentPust'], resolve)
        },
        {
          path: '/StudentInfo/yixiangstudentdetailsPust',
          name: '意向学员推送详情',
          component: resolve => require(['@/components/StudentInfo/yixiangstudentdetailsPust'], resolve)
        },
        // {
        //   path: '/StudentInfo/talentpool',
        //   name: '人才库',
        //   component: resolve => require(['@/components/StudentInfo/talentpool'], resolve)
        // },
        {
          path: "/postManagement/PostList",
          name: "邮寄列表",
          component: resolve => require(['@/components/postManagement/PostList'], resolve),
          meta: {
            keepAlive: true //此页面需要缓存
          }
        },
        {
          path: "/postManagement/PostDetail",
          name: "快递详情页",
          component: resolve => require(['@/components/postManagement/PostDetail'], resolve)
        },
        {
          path: "/usersprofile/userslist",
          name: "账户列表页",
          component: resolve => require(['@/components/usersprofile/userslist'], resolve)
        },
        {
          path: "/usersprofile/userdetail",
          name: "账户详情页",
          component: resolve => require(['@/components/usersprofile/userdetail'], resolve)
        },
        {
          path: "/usersprofile/role",
          name: "角色与权限列表",
          component: resolve => require(['@/components/usersprofile/role'], resolve),
        },
        {
          path: "/usersprofile/addrole",
          name: "添加角色与权限",
          component: resolve => require(['@/components/usersprofile/addrole'], resolve)
        },
        {
          path: "/inform/informlist",
          name: "通知列表",
          component: resolve => require(['@/components/inform/informlist'], resolve)
        },
        {
          path: "/email/emaillist",
          name: "", // 邮寄查询
          component: resolve => require(['@/components/email/emaillist'], resolve)
        },
        {
          path: "/cda/cdalist",
          name: "CDA班级列表",
          component: resolve => require(['@/components/cda/cdalist'], resolve)
        },
        {
          path: "/cda/cdaclassdetails",
          name: "CDA班级详情 ",
          component: resolve => require(['@/components/cda/cdaclassdetails'], resolve)
        },
        {
          path: "/cda/addcdastudent",
          name: "CDA学员添加",
          component: resolve => require(['@/components/cda/addcdastudent'], resolve)
        },
        // 考试管理
        {
          path: "/exam/historyTimeset",
          name: "历史考试时间",
          component: resolve => require(['@/components/exam/historyTimeset'], resolve)
        },
        {
          path: "/exam/timeset",
          name: "考试时间设定",
          component: resolve => require(['@/components/exam/timeset'], resolve)
        },
        {
          path: "/exam/applyinfo",
          name: "在线报名信息",
          component: resolve => require(['@/components/exam/applyinfo'], resolve),
          meta: {
            keepAlive: true //此页面需要缓存
          }
        },
        {
          path: "/exam/applyinfo/:way/:id",
          name: "在线报名信息查看/审核",
          component: resolve => require(['@/components/exam/applyinfoDetail'], resolve)
        },
        {
          path: "/exam/area",
          name: "考试地区申请",
          component: resolve => require(['@/components/exam/area'], resolve)
        },
        {
          path: "/exam/updateinfo",
          name: "考试信息修改",
          component: resolve => require(['@/components/exam/updateinfo'], resolve),
          meta: {
            keepAlive: true //此页面需要缓存
          }
        },
        {
          path: "/exam/certificate",
          name: "工信部证书查询",
          component: resolve => require(['@/components/exam/certificate'], resolve),
          // meta: {
          //   keepAlive: true //此页面需要缓存
          // }
        },
        {
          path: "/exam/updateinfo/:id",
          name: "考试信息修改页面",
          component: resolve => require(['@/components/exam/updateinfodetail'], resolve)
        },
        {
          path: "/exam/addinfo",
          name: "追加考生信息",
          component: resolve => require(['@/components/exam/addinfo'], resolve)
        },
        {
          path: "/exam/export",
          name: "考试成绩导出",
          component: resolve => require(['@/components/exam/export'], resolve)
        },
        // {
        //   path: "/exam/performance",
        //   name: "考试成绩导出",
        //   component: resolve => require(['@/components/exam/performance'], resolve)
        // },
        // CDA考试管理
        {
          path: "/examcda/timeset",
          name: "CDA考试时间设定",
          component: resolve => require(['@/components/examcda/timeset'], resolve)
        },
        {
          path: "/examcda/updateinfo",
          name: "CDA考试信息修改",
          component: resolve => require(['@/components/examcda/updateinfo'], resolve),
        },
        {
          path: "/examcda/updateinfo/:id",
          name: "CDA考试信息修改页面",
          component: resolve => require(['@/components/examcda/updateinfodetail'], resolve)
        },
        {
          path: "/examcda/addinfo",
          name: "CDA追加考生信息",
          component: resolve => require(['@/components/examcda/addinfo'], resolve)
        },
        {
          path: "/examcda/export",
          name: "CDA考试成绩导出",
          component: resolve => require(['@/components/examcda/export'], resolve)
        },
        {
          path: "/examcda/check",
          name: "CDA考试信息核对(上传)",
          component: resolve => require(['@/components/examcda/check'], resolve)
        },
        {
          path: "/examcda/examset",
          name: "CDA考试信息设置",
          component: resolve => require(['@/components/examcda/examset'], resolve)
        },
        {
          path: '/gw/courseorder',
          name: '课程订单',
          component: resolve => require(['@/components/gw/courseorder'], resolve)
        },
        {
          path: '/membercenter/individualMember',
          name: '个人会员',
          component: resolve => require(['@/components/membercenter/individualmember'], resolve),
          meta: {
            keepAlive: true //此页面需要缓存
          }
        },
        {
          path: '/membercenter/individualMemberDetail',
          name: '个人会员详情',
          component: resolve => require(['@/components/membercenter/individualMemberDetail'], resolve)
        },
        {
          path: '/membercenter/groupMembers',
          name: '团体会员',
          component: resolve => require(['@/components/membercenter/groupMembers'], resolve),
          meta: {
            keepAlive: true //此页面需要缓存
          }
        },
        {
          path: '/membercenter/groupMembersDetails',
          name: '团体会员详情',
          component: resolve => require(['@/components/membercenter/groupMembersDetails'], resolve)
        },
        {
          path: '/membercenter/groupApplication',
          name: '团体会员年检在线申请',
          component: resolve => require(['@/components/membercenter/groupApplication'], resolve),
          meta: {
            keepAlive: true //此页面需要缓存
          }
        },
        {
          path: '/membercenter/groupApplicationDetails',
          name: '团体会员年检在线申请详情',
          component: resolve => require(['@/components/membercenter/groupApplicationDetails'], resolve)
        },
        {
          path: '/membercenter/personalApplication',
          name: '个人会员在线年检申请',
          component: resolve => require(['@/components/membercenter/personalApplication'], resolve)
        },
        {
          path: '/membercenter/personalApplications',
          name: '项目填报',
          component: resolve => require(['@/components/membercenter/personalApplications'], resolve)
        },
        {
          path: '/membercenter/personalApplicationDetails',
          name: '个人会员在线年检申请详情',
          component: resolve => require(['@/components/membercenter/personalApplicationDetails'], resolve)
        },
        {
          path: '/membercenter/intentionGroup',
          name: '意向事务所',
          component: resolve => require(['@/components/membercenter/intentionGroup'], resolve),
          meta: {
            keepAlive: true //此页面需要缓存
          }
        },
        {
          path: '/membercenter/intentionGroupDetail',
          name: '意向事务所详情',
          component: resolve => require(['@/components/membercenter/intentionGroupDetail'], resolve)
        },
        {
          path: '/membercenter/free',
          name: '免费申请',
          component: resolve => require(['@/components/membercenter/free'], resolve)
        },

        {
          path: '/kechengservice/shalong',
          name: '课程服务-沙龙',
          component: resolve => require(['@/components/kechengservice/shalong'], resolve)
        },
        {
          path: '/kechengservice/diplacusis',
          name: '课程服务-复听申请',
          component: resolve => require(['@/components/kechengservice/diplacusis'], resolve),
          meta: {
            keepAlive: true //此页面需要缓存
          }
        },
        {
          path: '/kechengservice/activities',
          name: '课程服务-C币活动申请列表',
          component: resolve => require(['@/components/kechengservice/activities'], resolve)
        },
        {
          path: '/kechengservice/present',
          name: '课程服务-C币赠送',
          component: resolve => require(['@/components/kechengservice/present'], resolve),
        },
        {
          path: '/kechengservice/application',
          name: '课程服务-年检换证申请列表',
          component: resolve => require(['@/components/kechengservice/application'], resolve)
        },
        {
          path: '/kechengservice/diplacusisdetails',
          name: '课程服务-查看/审核',
          component: resolve => require(['@/components/kechengservice/diplacusisdetails'], resolve)
        },
        {
          path: '/kechengservice/adddiplacusis',
          name: '课程服务-详情',
          component: resolve => require(['@/components/kechengservice/adddiplacusis'], resolve)
        },
        {
          path: '/kechengservice/CertificateDown',
          name: '课程服务-证书下载',
          component: resolve => require(['@/components/kechengservice/CertificateDown'], resolve)
        },
        {
          path: '/kechengservice/openclassList',
          name: '课程服务-发送课程',
          component: resolve => require(['@/components/kechengservice/openclassList'], resolve),
        },
        {
          path: '/kechengservice/classmanageList',
          name: '课程服务-课程管理',
          component: resolve => require(['@/components/kechengservice/classmanageList'], resolve),
        },
        {
          path: '/index/backlog',
          name: '首页-代办事项',
          component: resolve => require(['@/components/index/backlog'], resolve)
        },
        {
          path: '/gw/apply',
          name: '官网-报名记录',
          component: resolve => require(['@/components/gw/apply'], resolve),
        },
        {
          path: '/gw/gryh',
          name: '官网-个人优惠记录',
          component: resolve => require(['@/components/gw/gryh'], resolve),
        },
        {
          path: '/gw/addGryh',
          name: '新增个人优惠记录',
          component: resolve => require(['@/components/gw/addGryh'], resolve)
        },
        {
          path: '/gw/fhbm',
          name: '官网-峰会报名',
          component: resolve => require(['@/components/gw/fhbm'], resolve),
        },
        {
          path: '/gw/courseorder',
          name: '官网-缴费',
          component: resolve => require(['@/components/gw/courseorder'], resolve)
        },
        {
          path: '/gw/applyDetail',
          name: '官网-缴费详情',
          component: resolve => require(['@/components/gw/applyDetail'], resolve)
        },
        {
          path: '/gw/recruit',
          name: '官网-招募页',
          component: resolve => require(['@/components/gw/recruit'], resolve),
        },
        {
          path: '/newdh/studentlist',
          name: '新学员列表',
          component: resolve => require(['@/components/newDh/studentlist'], resolve),
        },
        {
          path: '/newdh/openclassList',
          name: '新发送课程',
          component: resolve => require(['@/components/newDh/openclassList'], resolve),
        },
        {
          path: '/newdh/classmanageList',
          name: '新课程管理',
          component: resolve => require(['@/components/newDh/classmanageList'], resolve),
        }
      ]
    }
  ],
  mode: 'history',
  scrollBehavior(to,from,savePosition){
    if(savePosition){
      //解决页面从列表页跳转到详情页返回,初始在原来位置
      return savePosition
    }else{
      //解决页面跳转后页面高度和前一个页面高度一样
      return {x:0,y:0}
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js